<template>
  <div class="page_container">
    <div class="page_inner">
      <div class="page_content mt20">
        <div class="Tb_data_setting">
          <ul>
            <li>
              <router-link to="/user/member-info">
                <div class="setting_user-info">
                  <img src="@/assets/images/setting/user.png" alt="user icon" />
                  {{ userName }}
                </div>
              </router-link>
            </li>

            <li>
              <div class="setting-list-title">{{ $t('setting.ex') }}</div>
              <div class="setting-list-content-wrap">
                <router-link to="/user/recommend-info" class="setting-link">
                  <div class="setting_content-info">
                    <img src="@/assets/images/setting/referral.png" alt="user icon" />
                    {{ $t('mypage.referralInfo') }}
                  </div>
                </router-link>
                <router-link to="/user/subscribe-info" class="setting-link">
                  <div class="setting_content-info">
                    <img src="@/assets/images/setting/subscript.png" alt="user icon" />
                    {{ $t('mypage.mySubInfo') }}
                  </div>
                </router-link>
              </div>
            </li>

            <li>
              <div class="setting-list-title">{{ $t('setting.support') }}</div>
              <div class="setting-list-content-wrap">
                <router-link to="/user/setting-general" class="setting-link">
                  <div class="setting_content-info">
                    <img src="@/assets/images/setting/language.png" alt="user icon" />
                    {{ $t('mypage.languageSetting') }}
                  </div>
                </router-link>
                <a href="https://t.me/EXCSTEAM" class="setting-link">
                  <div class="setting_content-info">
                    <img src="@/assets/images/setting/contact.png" alt="user icon" />
                    {{ $t('mypage.contactUs') }}
                  </div>
                </a>
              </div>
            </li>
<!-- 
            <li>
              <router-link to="/user/member-info">
                <h2 class="set_01">{{ $t('mypage.userInfo') }}</h2>
              </router-link>
            </li>
            <li>
              <router-link to="/user/recommend-info">
                <h2 class="set_02">{{ $t('mypage.referralInfo') }}</h2>
              </router-link>
            </li>
            <li>
              <router-link to="/user/subscribe-info">
                <h2 class="set_03">{{ $t('mypage.mySubInfo') }}</h2>
              </router-link>
            </li>
            <li>
              <router-link to="/user/construction">
                <h2 class="set_04">{{ $t('mypage.connectExAPI') }}</h2>
              </router-link>
            </li>
            <li>
              <router-link to="/user/setting-general">
                <h2 class="set_06">{{ $t('mypage.languageSetting') }}</h2>
                <p class="setting_value">{{ selectLocale }}</p>
              </router-link>
            </li>
            <li>
              <a href="https://t.me/EXCSTEAM">
                <h2 class="set_09">{{ $t('mypage.contactUs') }}</h2>
              </a>
            </li> -->
            <li>
              <a href="#none" @click="handleLogout" class="logout">
                <h2 class="set_10">{{ $t('mypage.logout') }}</h2>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const selectLocale = ref("");
const userName = computed(() =>  localStorage.getItem("userName"));


// 기존 created 라이프사이클 영역 (script setup 최상단에 작성하면 컴포넌트 생성 시 바로 실행됩니다)
const getLocale = localStorage.getItem("localeLang") || "en";
if (getLocale == "ko") {
  selectLocale.value = "한국어";
} else if (getLocale == "en") {
  selectLocale.value = "English";
} else if (getLocale == "ja") {
  selectLocale.value = "日本語";
} else if (getLocale == "zh") {
  selectLocale.value = "中文";
} else if (getLocale == "vi") {
  selectLocale.value = "Tiếng Việt";
} else if (getLocale == "ru") {
  selectLocale.value = "Русский язык";
}

const resetState = () => {
  store.commit("user/changeApi", { state: false });
  store.commit("user/changeAgree", { state: false });
  store.commit("user/changeDelete", { state: false });
  store.commit("user/changePosition", { state: false });
};

const handleLogout = () => {
  if (window.webkit && window.webkit.messageHandlers.logoutHandler) {
    window.webkit.messageHandlers.logoutHandler.postMessage('User logged out');
  }

  if (window.Android) {
    window.Android.logoutTriggered();
  }
};

// 기존 mounted 라이프사이클 영역
onMounted(() => {
  resetState();
});
</script>